import CtaButtonWithIcon from 'components/formComponents/Base/CtaButtonWithIcon';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import styles from './ReportDismissedSection.module.scss';
import { CYPRESS_DATA } from './constants';
import ExcelImportButton from './ExcelImportButton';
import TemplateDownloadButton from './TemplateDownloadButton';

type Props = {
  isImporting: boolean;
  registerDismissedAddBtnText: string;
  importFileBtnText: string;
  downloadTemplateBtnText: string;
  downloadCopyBtnText: string;
  templateFileUrl: string;
  onAdd: () => void;
  onFileSelected: (file: File) => void;
};

const EmptyState = ({
  isImporting,
  onAdd,
  onFileSelected,
  registerDismissedAddBtnText,
  importFileBtnText,
  downloadTemplateBtnText,
  downloadCopyBtnText,
  templateFileUrl,
}: Props) => (
  <div className={styles.emptyState} data-cy={CYPRESS_DATA.emptyState}>
    <div className={styles.emptyStateActions}>
      <div className={styles.toolbarAction}>
        <CtaButtonWithIcon
          type="button"
          label={registerDismissedAddBtnText ?? 'Lägg till uppsagd'}
          Icon={AddCircleOutlineIcon}
          onClick={onAdd}
          dataCy={CYPRESS_DATA.addButton}
        />
      </div>
      <ExcelImportButton
        disabled={isImporting}
        onFileSelected={onFileSelected}
        importFileBtnText={importFileBtnText}
      />
      <TemplateDownloadButton
        employees={[]}
        downloadTemplateBtnText={downloadTemplateBtnText}
        downloadCopyBtnText={downloadCopyBtnText}
        templateFileUrl={templateFileUrl}
      />
    </div>
  </div>
);

export default EmptyState;
